<svg fill="var(--anatomy-gray-500)" height="4.5em" style="flex:none;line-height:1;background:var(--anatomy-gray-100)" viewBox="0 0 501.71 444.05" width="5.07em" xmlns="http://www.w3.org/2000/svg">
  <path d="m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05h297.58z" stroke-width="0"/>
</svg>
